// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(min-width: 601px)";
var _4 = "contactsSection-3uxBM";
var _5 = "input-3mW94";
export { _1 as "__esModule", _2 as "mobile", _3 as "exclude_mobile", _4 as "contactsSection", _5 as "input" }
export default { "__esModule": _1, "mobile": _2, "exclude_mobile": _3, "contactsSection": _4, "input": _5 }
